export enum SportSourceEnum {
  FOOTBALL = "FOOTBALL",
  CUSTOM = "CUSTOM",
}
